<template>
  <v-slider
    v-model="formInput.$model"
    :always-dirty="true"
    :min="min"
    :max="maxVal"
    :step="step"
    :show-ticks="ticks"
    :tick="tickLabels"
    @update:modelValue="$emit('change', $event)"
  />
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import BaseTextField from '../BaseTextField.vue';

export function tickLabelMapper(option: { label?: string; value: number } | number | string) {
  if (typeof option === 'object') {
    return option.label ?? option.value;
  }
  return option;
}

export function optionValueMapper(option: { value: number }) {
  return typeof option === 'number' ? option : option.value;
}

const componentOptions: ComponentOptions = {
  name: 'SliderComponent',
  extends: BaseTextField,
  props: {
    max: {
      type: Number,
      default: undefined,
    },
    min: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    modelName: 'sliderValue',
    sliderValue: 0,
  }),
  computed: {
    maxVal() {
      return this.options ? this.options.length - 1 : this.max;
    },
    tickLabels() {
      return this.options ? this.options.map(tickLabelMapper) : undefined;
    },
    ticks() {
      return this.options ? 'always' : undefined;
    },
  },
  methods: {
    onChange(event: string) {
      const value = this.options?.[event] ? this.options[event] : event;
      BaseTextField?.methods?.onChange.bind(this)(typeof value === 'object' ? value.value : value);
    },
  },
};
export default defineComponent(componentOptions);
</script>
